import axios from 'axios'
import { Tool, PostTool, UpdateTool } from './interfaces'
import GetJsonData from './dataAccess'

const apiURL = process.env.REACT_APP_API_URL

export const getTools = async (): Promise<Tool[]> => {
  const data = await GetJsonData('tool')

  const toolData: Tool[] = (data as Tool[]).map((item: any) => ({
    toolId: item.toolId,
    make: item.make,
    model: item.model,
    serialNo: item.serialNo,
    lastCalibrated: item.lastCalibrated,
    nextCalibration: item.nextCalibration,
    employeeName: item.employeeName,
    employeeId: item.employeeId,
    archived: item.archived,
    createDate: item.createDate,
    employeeCreatedbyName: item.employeeCreatedbyName,
    modifiedDate: item.modifiedDate,
    employeeModifiedbyName: item.employeeModifiedbyName,
    isCalibrationDue: item.isCalibrationDue,
    costsToDate: item.costsToDate,
  }))

  return toolData
}

export const getToolById = async (toolId: number): Promise<Tool> => {
  const data = await GetJsonData(`tool/${toolId}`)
  return data as Tool
}

export const submitTool = async (tool: PostTool): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.post(`https://${apiURL}/tool`, tool, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    }
  })
  return response.data
}

export const updateTool = async (tool: UpdateTool, toolId: number): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.put(`https://${apiURL}/tool/${toolId}`, tool, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    }
  })
  return response.data
}

export const deleteTool = async (toolId: number): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.delete(`https://${apiURL}/tool/${toolId}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    }
  })
  return response.data
}

export const getToolDocuments = async (toolId: number) => {
  const token = localStorage.getItem('authToken')
  const storedApiURL = localStorage.getItem('apiURL')
  const finalApiURL = storedApiURL || apiURL

  if (!token) {
    throw new Error('Authorization token not found')
  }

  try {
    const response = await axios.get(
      `https://${finalApiURL}/tool/${toolId}/documents`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching tool documents:', error)
    return []
  }
}
